import CheckData from '../../../../../components/CatchError';
import DataTable from '../../../../../components/Datatable';
import LoadMoreComponent from '../../../../../components/LoadMoreComponent';
import { changeIntent } from '../../../../../helpers/commerce';
import { downloadAllCsv } from '../../../../../helpers/downloadAll';
import { sleep } from '../../../../../helpers/sleep';
import { getSortKeys, setAdditionalStyles } from '../../../../../helpers/table';
import AdditionalBox from './additionalBox';
import ExtraButtons from './extraBtn';
import { COLUMNS } from './keys';
import query from './query';
import { v4 as uuid } from 'uuid';

const tabs = [
    {
        icon: 'icon-fi_grid',
        label: 'All',
        key: 'all',
        hint: '',
    },
    {
        icon: 'icon-grid-03',
        label: 'Striking distance',
        key: 'striking_distance',
    },
    {
        icon: 'icon-file-04',
        label: 'Page 2',
        key: 'page_2',
    },
    {
        icon: 'icon-intersect-circle',
        label: 'Long tail',
        key: 'long_tail',
    },
    {
        icon: 'icon-arrows-right',
        label: 'Low Keyword Difficulty',
        key: 'low_keyword_difficulty',
    },
    {
        icon: 'icon-arrows-right',
        label: 'Not Ranking',
        key: 'not_ranking',
    },
];

class Keywords extends LoadMoreComponent {
    constructor(props) {
        super();
        if (!props.data)
            this.query = query({
                project_id: props.project_id,
                domain: props.own_domain,
                offset: 0,
            });

        this.url = new URL(window.location);
        this.search = this.url.searchParams.get('search');
        this.intent = this.url.searchParams.get('intent');

        this.onFilter = this.onFilter.bind(this);
        this.exportAll = this.exportAll.bind(this);
        this.customForceRun = this.customForceRun.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.offsetStep = 1000;

        this.options = [
            { label: 'Commercial', value: 0 },
            { label: 'Informational', value: 1 },
            { label: 'Navigational', value: 2 },
            { label: 'Transactional', value: 3 },
        ];

        const breadcrumbBox = document.getElementById('breadcrumb-box');
        if (breadcrumbBox)
            breadcrumbBox.innerHTML = `<a class="text-primary domain-name" aria-current="page" href="/commerce/">Commerce</a><i class="icon-arrow-right"></i> <a href="#" >Project: ${props.keyword} </a> <i class="icon-arrow-right"></i> <a href="#" >Keywords</a>`;
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item?.keyword?.toLowerCase()?.includes(search.toLowerCase()));
    }

    async componentDidUpdate(prevProps, prevState) {
        if (this.state.data && JSON.stringify(this.state.data) !== JSON.stringify(prevState.data)) {
            this.props.updateDatas({ key: 'allData', value: this.state.data });
        }

        const filters = localStorage.getItem('filters');
        const data = this.state.data?.map((x) => ({ id: uuid(), ...x }));

        if (prevState.filters !== filters && !this.state.loading) {
            return this.setState({ allData: data, filters });
        }

        if (
            JSON.stringify(this.state.data) !== JSON.stringify(prevState.data) &&
            !this.state.loading
        ) {
            this.setState({ allData: [...this.state.allData, ...data] });
            if (this.intent) {
                const filter = this.options.filter((item) => this.intent?.includes(item.value));
                await sleep(0);
                this.onFilter({ select: filter });
            }
        }
    }

    checkIntent(itemIntent, selectedIntent) {
        for (let i = 0; i < selectedIntent?.length; i++) {
            if (itemIntent.includes(selectedIntent[i])) return true;
        }
        return false;
    }

    customForceRun() {
        this.setState({
            allData: [],
            data: [],
        });
        this.forceRun();
        this.props.updateDatas({ key: 'allData', empty: true });
    }

    onFilter({ toggle, select, min_search_volume, max_search_volume }) {
        let data = this.state.allData?.length ? this.state.allData : this.props.data;
        const toggleValue = toggle ?? this.state.toggle;
        const max = max_search_volume ?? this.state.max_search_volume;
        const min = min_search_volume ?? this.state.min_search_volume;

        let selectValue =
            select?.map((item) => item.value) || this.state.select?.map((item) => item.value) || [];

        let sortedValues = [];

        switch (toggleValue) {
            case 'all': {
                sortedValues = data;
                break;
            }
            case 'striking_distance': {
                sortedValues = data.filter((item) => item.position > 4 && item.position <= 10);
                break;
            }
            case 'page_2': {
                sortedValues = data.filter((item) => item.position > 10);
                break;
            }
            case 'long_tail': {
                sortedValues = data.filter((item) => item.keyword?.split(' ')?.length > 3);
                break;
            }
            case 'low_keyword_difficulty': {
                sortedValues = data.filter(
                    (item) =>
                        item.keyword_difficulty_index >= 1 && item.keyword_difficulty_index <= 30,
                );
                break;
            }
            case 'not_ranking': {
                sortedValues = data.filter((item) => !item.position);
                break;
            }
            default:
                sortedValues = data;
        }

        if (selectValue?.length !== 0) {
            sortedValues = sortedValues.filter((item) =>
                this.checkIntent(item.intent, selectValue),
            );
        }

        sortedValues = sortedValues.filter((item) => {
            if (min && max) {
                return item.search_volume >= Number(min) && item.search_volume <= Number(max);
            }

            if (min) {
                return item.search_volume >= Number(min);
            }
            if (max) {
                return item.search_volume <= Number(max);
            }

            return true;
        });

        this.setState({
            toggle: toggleValue,
            sortedValues,
        });
    }

    async exportAll() {
        try {
            let data = this.state.allData?.length ? this.state.allData : this.props.data;
            this.setState({
                exportAllLoading: true,
            });

            downloadAllCsv(data, 'Commerce All Data', COLUMNS(this.props.project_id));
            this.setState({
                exportAllLoading: false,
            });
        } catch (err) {
            this.setState({
                exportAllLoading: false,
            });
            console.log(err);
        }
    }

    handleSelectChange(values) {
        this.setState({
            select: values,
        });
        changeIntent(values);
        this.props.updateDatas({ emptyAll: true });

        this.onFilter({ select: values });
    }

    render() {
        let data = this.state.allData?.length ? this.state.allData : this.props.data;

        data = this.state.sortedValues || data;
        const additionalBox = () => (
            <AdditionalBox
                onFilter={this.onFilter}
                data={data}
                loading={this.state.loading}
                select={this.state.select}
                handleSelectChange={this.handleSelectChange}
            />
        );

        const extraBtns = () => <ExtraButtons />;
        return (
            <>
                <div className="card rounded-main overflow-hidden opportunity-box">
                    <div className="card-body">
                        <div className="box-header">Oppoprtunities</div>
                        <div className="opportunity-box-items">
                            {tabs.map((item) => (
                                <div
                                    key={item.key}
                                    className="toggle-Invalid-items"
                                    title={item.hint}
                                >
                                    <span
                                        className={`switch-button without-text mr-10 ${
                                            (this.state.toggle ?? 'all') === item.key
                                                ? 'active'
                                                : 'not-active'
                                        }`}
                                        onClick={() => this.onFilter({ toggle: item.key })}
                                    >
                                        <span className="switch-circle" />
                                    </span>
                                    <span>{item.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="card rounded-main table-main">
                    <div>
                        <CheckData
                            data={data}
                            loading={!data?.length && this.state.loading}
                            loadMore={this.state.loadMore}
                        >
                            <DataTable
                                nodes={data}
                                sortFns={getSortKeys(COLUMNS())}
                                COLUMNS={COLUMNS(this.props.project_id, this.props.own_domain)}
                                fileName="Top Pages"
                                header={` Keywords: [${this.props.keyword}]`}
                                forceRun={this.customForceRun}
                                additionalBox={additionalBox}
                                extraBtns={extraBtns}
                                defaultSortKey={'search_volume'}
                                searchFunction={this.searchFunction}
                                additionalStyles={setAdditionalStyles(COLUMNS())}
                                defaultSearch={this.search}
                                customEmptyMessage="No Data available"
                                exportAll={this.exportAll}
                                exportAllLoading={this.state.exportAllLoading}
                            />
                        </CheckData>
                    </div>
                </div>
            </>
        );
    }
}

export default Keywords;
